export class ParamOchannel {
  id?: string;
  param_id: string;
  ochannel_id: string;
  conversion_code: string;
  description?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/promotion-param-ochannel.model.ts